import { useSelector } from 'react-redux';
import config from '../config';
import { RootState } from '../types/graph';

type SurveyURLProps = {
  page?: string;
  maxScore?: number;
  rating?: number;
};

export const useSurveyURL = ({ page, maxScore, rating }: SurveyURLProps) => {
  const variant = useSelector((state: RootState) => state.graph.variant);

  const url = new URL(config.surveyUrl);

  url.searchParams.set('utm_source', 'in-app');
  if (page) url.searchParams.set('utm_medium', page);
  if (variant) {
    url.searchParams.set('utm_content', variant);
    url.searchParams.set('variant', variant);
  }
  if (maxScore) url.searchParams.set('maxScore', maxScore.toString());
  if (rating) url.searchParams.set('rating', rating.toString());
  return url.toString();
};
